module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "dedication"
    }
  }, [_c('h1', [_vm._v("Dedication")]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("For Olivia, Amber and Luca – my daily motivation.")]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("For Massimo – my biggest supporter and mentor.")]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("Costantino – Loyalty and opportunity many times over in my life.")]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("For Felicity, Phil and all the other poor souls struggling with life.")]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("Marellon – my oldest school friend.")]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("Ann and Bill W – for putting me on the right path and those great summer school holidays.")]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("Sally B –A fantastic teacher.")]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("Ken – For all you did for us.")]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("John F – 20 years of selling scooters together and against each other!")]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("George D – recipient of my woofing pants more times than I care to mention and an enduring friendship over many years.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ab9d586","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch002.vue
// module id = 66
// module chunks = 0